export default "__VITE_ASSET__Za$hKoVl__"